import { format } from "date-fns";

export const toDate = (date: Date) => {
  return format(new Date(date), "dd/MM/yyyy");
};
